<template>
  <div class="banner">
    <cube-slide :data="headImages" :options="{ click: true }">
      <cube-slide-item v-for="(item, index) in headImages" :key="index">
        <div class="head-image-container flex-center">
          <img
            @click="$fn.jump(item.link)"
            class="head-image-item"
            :src="item.image"
            alt=""
          />
        </div>
      </cube-slide-item>
      <template slot="dots" slot-scope="props">
        <span
          class="my-dot"
          :class="{ active: props.current === index }"
          v-for="(item, index) in headImages.length"
          :key="index"
        ></span>
      </template>
    </cube-slide>
  </div>
</template>

<script>
import { mapState } from "vuex";
import api from "@/api/api-list";
import { componentsMixin } from "@/assets/js/mixin/components";
import { envMixin } from "@/assets/js/mixin/global";

export default {
  name: "CvsBanner",
  mixins: [componentsMixin, envMixin],
  props: {
    // bannerData: {
    //   type: Array,
    //   default: []
    // }
    position: {
      type: Number,
      default: 16,
    },
  },
  data() {
    return {
      headImages: [],
    };
  },
  computed: {},
  async created() {
    if (this.isAlipayClient || this.isBaidu) {
      this.$emit("hidBanner");
      return;
    }
    try {
      let res = await api.jobs.getBannerImg({ position: this.position });
      if (res.code === 1000) {
        if (res.data.length > 0) {
          this.headImages = res.data;
        } else {
          this.$emit("hidBanner");
        }

        // this.headImages.push({image: 'https://i.carimg.com/store/371/160/000/059eed80e22429.jpg!zmm', link: 'https//m.wondercv.cn'})
      } else {
        this.$emit("hidBanner");
        // this.showToast(res.message)
      }
    } catch (e) {
      console.log(e);
    }
  },
  methods: {
    toBlogDetail(obj) {
      if (obj.link) {
        console.log(this.$fn);
        this.$fn.jump(obj.link);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/global/variable";
@import "@/assets/scss/global/mixin";
.banner {
  width: 100%;
  height: 100%;
  .head-image-container {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    .head-image-item {
      height: 100%;
      border-radius: 6px;
      width: 100%;
    }
  }

  /deep/ .cube-slide-dots {
    padding-bottom: 6px;

    .my-dot {
      display: inline-block;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: #c4c4c6;
      margin-right: 10px;
      padding-bottom: 6px;

      &:last-child {
        margin-right: 0;
      }
    }

    .active {
      background-color: $color-light;
    }
  }
}
</style>
